/* eslint-disable jira/filename-case */
import {
	UFOExperience,
	ExperienceTypes,
	ExperiencePerformanceTypes,
} from '@atlassian/ufo/ufo-experimental';
import { createJpdExperience } from './createJpdExperience.tsx';
import type {
	ExperienceErrorReason,
	ExperienceMetadataExtra,
	JPDExperience,
} from './ExperienceMetadataExtra.types.tsx';

export const loadIssuesRestBatched: JPDExperience = createJpdExperience(
	new UFOExperience('jpd.issues.load.rest-batched', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const loadIssueRest: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.issue.load.rest', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);

export const loadIssuesJpdApi: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.issues.load.jpd-api', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);

export const loadIssueJpdApi: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.issue.load.jpd-api', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);

export const loadIssuesRanksRestBatched: JPDExperience<
	ExperienceErrorReason,
	ExperienceMetadataExtra
> = createJpdExperience(
	new UFOExperience('jpd.issues.ranks.load.rest-batched', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const loadIssuesRanksJpdApi: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.issues.ranks.load.jpd-api', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);
export const rankIssue: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.issue.rank', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);

export const loadIssuePickerIssuesRest: JPDExperience<
	ExperienceErrorReason,
	ExperienceMetadataExtra
> = createJpdExperience(
	new UFOExperience('jpd.issue-picker.load', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const globalJpdIssueCreate: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.global.jpd.create-issue', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);
